import axios from 'axios';

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

AxiosInstance.interceptors.request.use((config) => {
  const language = localStorage.getItem('language');
  if (language) {
    config.headers.language = language;
  } else {
    config.headers.language = 'en';
  }

  const token = document.cookie
    .split('; ')
    .find((row) => row.startsWith('XSRF-TOKEN='))
    ?.split('=')[1];

  if (token) {
    config.headers['X-XSRF-TOKEN'] = token;
  }

  return config;
});

export default AxiosInstance;
